import styled, { css } from "styled-components";
import { SmallText } from "./HXDesktopPage.styles";
import { Title } from "./PatientConsentManagerShared.styles";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { createFadeInAnimation, createSlideAnimation, createVerticalSlideAnimation } from "./animations.styles";
export const DetailsTextLink = styled(SmallText) `
    text-decoration: underline;
    padding: 0px;
`;
export const LogosContainer = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    height: 88px;
    width: 205.7px;
    position: relative;
    align-self: center;
`;
const dashedLineAnimation = createVerticalSlideAnimation("calc(20vh - 50%)", true);
export const DashedLineImage = styled.img `
    position: absolute;
    left: 92.4px;
    top: 44px;
    width: 20.9px;
    height: auto;

    ${(props) => props.animate &&
    css `
            animation: ${dashedLineAnimation} 500ms linear 500ms both;
        `}
`;
const orgLogoAnimation = createSlideAnimation("59px", "calc(20vh - 50%)");
export const OrgLogoCircle = styled.div `
    position: absolute;
    left: 0;
    top: 0;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    border: 0.917px solid rgba(29, 98, 174, 0.3);
    background-color: ${colors.white_main};
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    z-index: 2;
    overflow: hidden;

    ${(props) => props.animate &&
    css `
            animation: ${orgLogoAnimation} 500ms linear 500ms both;
        `}
`;
export const OrgLogoImage = styled.img `
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
const healthExLogoAnimation = createSlideAnimation("-59px", "calc(20vh - 50%)");
export const HealthExLogoCircle = styled.div `
    position: absolute;
    left: 117.7px;
    top: 0;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    border: 0.917px solid rgba(29, 98, 174, 0.3);
    background: linear-gradient(135deg, #ffd881 0%, #ff8a2d 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    z-index: 1;
    overflow: hidden;

    ${(props) => props.animate &&
    css `
            animation: ${healthExLogoAnimation} 500ms linear 500ms both;
        `}
`;
export const HealthExLogoImage = styled.img `
    height: 29.33px;
    object-fit: cover;
`;
const titleAnimation = createVerticalSlideAnimation("calc(20vh - 50%)");
const textAnimation = createFadeInAnimation(0, 1);
export const WelcomeTitle = styled(Title) `
    text-align: center;
    font-size: ${fontSizes.MOBILE_TITLE};
    line-height: 36px;
    font-weight: 500;
    color: ${colors.black_main};

    ${(props) => props.animate &&
    css `
            animation: ${titleAnimation} 500ms linear 500ms both;
        `}
`;
export const SupportingText = styled.p `
    font-size: ${fontSizes.STANDARD};
    font-weight: normal;
    line-height: normal;
    color: ${colors.black_light};
    text-align: center;
    letter-spacing: 0.15px;
    margin: 0;
    opacity: ${(props) => (props.animate ? 0 : 1)};

    ${(props) => props.animate &&
    css `
            animation: ${textAnimation} 400ms linear 600ms both;
        `}
`;
